export const emptyPlaidTokenData = {
  token: '',
};
